import { isDesktopApp } from './environment';

export function browserOrDesktop<T>(ifBrowser: T, ifDesktop: T): T {
  return isDesktopApp ? ifDesktop : ifBrowser;
}
